// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { cartLinkStyles } from "@eisinc/Overrides/Widgets/Common/CartLink";
import { fontConfig } from "@eisinc/XDL/PreStyle/typography";
import { color, xScreen } from "@eisinc/XDL/Utilities";
import { css } from "styled-components";

cartLinkStyles.routerLinkStyles = {
    css: css`
        flex-direction: column;
        &:hover,
        &:focus {
            text-decoration: none;
        }
        ${xScreen("lte", "md")} {
            align-items: flex-start;
        }
    `,
};

cartLinkStyles.cartTotalStyles = {
    css: css`
        font-size: ${fontConfig.singleLineSmall.size}px;
        line-height: ${fontConfig.singleLineSmall.lineHeight};
        font-weight: ${fontConfig.weight.medium};
        text-align: center;
        min-height: 17px;
        min-width: 37px;
        color: ${color("text.main")};

        ${xScreen("lte", "md")} {
            display: none;
        }
    `,
};
cartLinkStyles.cartIconCountWrapper = {
    css: css`
        position: relative;
    `,
};
cartLinkStyles.cartCountStyles = {
    css: css`
        position: absolute;
        top: -6px;
        left: 12px;
        background: ${color("primary")};
        min-width: 26px;
        border-radius: 2px;
        line-height: normal;
        color: ${color("common.white")};
        text-align: center;
        padding: 1px 4px;
        border: 1px solid ${color("common.white")};
        height: 18px;
        display: flex;
        justify-content: center;
        align-items: center;

        & span {
            font-size: ${fontConfig.singleLinexSmall.size}px;
            line-height: ${fontConfig.singleLinexSmall.lineHeight};
            font-weight: ${fontConfig.weight.medium};
        }
        ${xScreen("lte", "md")} {
            left: 8px;
        }
    `,
};
cartLinkStyles.cartIconStyles = {
    css: css`
        & > svg {
            fill: ${color("text.main")};
        }
    `,
};
cartLinkStyles.compactCountText = {
    css: css`
        font-weight: normal;
    `,
};
cartLinkStyles.cartLinkWrapper = {
    css: css`
        min-width: 33px;
    `,
};
cartLinkStyles.tooltip = {
    tooltipContent: {
        css: css`
            max-width: initial;
            width: 640px;
            padding: 0;
        `,
    },
};
